// Module
var code = "<div class=\"btn-group\"><select class=\"form-control btn\" ng-model=\"newFilter.user_value\" ng-options=\"location.name as location.name for location in locations\"><option disabled=\"disabled\" value=\"\">Value</option></select></div>\n";
// Exports
module.exports = code;